/**
 * 进程管理
 */
const DispatchRouter = {
  path: '/project',
  component: () => import('@/views/layout'),
  redirect: '/project/manage/list',
  hidden: true,
  meta: {
    title: 'desc',
  },
  children: [
    // 详情
    {
      path: 'dispatch/desc/:id',
      name: 'disp_desc',
      component: () => import('@/views/dispatch_order/components/desc'),
      hidden: true,
      meta: {
        title: '详情'
      }
    },
    {
      path: 'dispatch/makedesc/:id',
      name: 'DescDispatch',
      component: () => import('@/views/approval/details'),
      hidden: true,
      meta: {
        title: '详情'
      }
    },

    // 编辑。根据情况判断进入那个编辑页面

    {
      path: 'dispatch/CB/edit/:id',
      name: 'CBedit',
      component: () => import('@/views/all_project/CB/edit_project'),
      hidden: true,
      meta: {
        title: '编辑'
      }
    },

    {
      path: 'dispatch/LB/edit/:id',
      name: 'LBedit',
      component: () => import('@/views/all_project/LB/edit_project'),
      hidden: true,
      meta: {
        title: '编辑'
      }
    },
    {
      path: 'dispatch/LW/edit/:id',
      name: 'LWedit',
      component: () => import('@/views/all_project/LW/edit_project'),
      hidden: true,
      meta: {
        title: '编辑'
      }
    },

    {
      path: 'dispatch/ZX/edit/:id',
      name: 'ZXedit',
      component: () => import('@/views/all_project/ZX/edit_project'),
      hidden: true,
      meta: {
        title: '编辑'
      }
    },
    {
      path: 'dispatch/FP/edit/:id',
      name: 'FPedit',
      component: () => import('@/views/all_project/FP/edit_project'),
      hidden: true,
      meta: {
        title: '编辑'
      }
    },
    {
      path: 'dispatch/KT/edit/:id',
      name: 'KTedit',
      component: () => import('@/views/all_project/KT/edit_project'),
      hidden: true,
      meta: {
        title: '编辑'
      }
    },

    // 创建派遣单 路由
    {
      path: 'dispatch/order1/:id',
      name: 'cb_order',
      component: () => import('@/views/dispatch_order/careatorder/CB'),
      hidden: true,
      meta: {
        title: '创建派遣单'
      }
    },
    {
      path: 'dispatch/order2/:id',
      name: 'lb_order',
      component: () => import('@/views/dispatch_order/careatorder/LB'),
      hidden: true,
      meta: {
        title: '创建派遣单'
      }
    },
    {
      path: 'dispatch/order3/:id',
      name: 'lw_order',
      component: () => import('@/views/dispatch_order/careatorder/LW'),
      hidden: true,
      meta: {
        title: '创建派遣单'
      }
    },
    {
      path: 'dispatch/order4/:id',
      name: 'zx_order',
      component: () => import('@/views/dispatch_order/careatorder/ZX'),
      hidden: true,
      meta: {
        title: '创建派遣单'
      }
    },
    {
      path: 'dispatch/order5/:id',
      name: 'kt_order',
      component: () => import('@/views/dispatch_order/careatorder/KT'),
      hidden: true,
      meta: {
        title: '创建派遣单'
      }
    },
    {
      path: 'dispatch/order6/:id',
      name: 'fp_order',
      component: () => import('@/views/dispatch_order/careatorder/FP'),
      hidden: true,
      meta: {
        title: '创建派遣单'
      }
    },

  ]
}

export default DispatchRouter
